var Assess = function(){

    var _init = function(){

        $(".preflight-prev").on('click',function(){
            if(previewPointer > 0){
                Assess.showTab(previewPointer-1,'prev');
            }
        });

        $(".preflight-next").on('click',function(){
            Assess.showTab(previewPointer+1,'next');
        });
    
        $('#promana-assess-skip').click( function(){
            Assess.processChoice(uuid,pair,'X');
        });
    
        $('#promana-assess-next').click( function(){
            var choice = $('input[type="radio"]:checked').val();
            if(typeof(choice) == 'undefined'){
                Do.Notify({
                    title: '',
                    class: 'warning',
                    content: warn,
                    delay: 5000
                });
            }else{
                Assess.processChoice(uuid,pair,choice);
            }
        });
        
    }

    var _progressLoader = function(){
        $('.promana-survey-spinner-bg').removeClass('d-none').addClass('d-inline-block');
    }

    var _showTab = function(p,b){
        if(p < 0){p=0;}
        if(b=='next'){
            if(!$('#steps-preflight-0-h-'+(p+1)).length){
                $('.preflight-next').addClass('text-muted');
                // return;
            }
            if($('#steps-preflight-0-h-'+(p)).length){
                $(".preflight-prev").removeClass('text-muted');
                $('#steps-preflight-0-h-'+(p-1)).removeClass('active show');
                $('#steps-preflight-0-h-'+(p)).addClass('active show');
                previewPointer = p;
            }
        }else{
            if(p==0){
                $(".preflight-prev").addClass('text-muted');
            }else if($('#steps-preflight-0-h-'+(p+1)).length){
                $(".preflight-prev").removeClass('text-muted');
                $(".preflight-next").removeClass('text-muted');
                $('#steps-preflight-0-h-'+(p)).addClass('active show');
                $('#steps-preflight-0-h-'+(p+1)).removeClass('active show');
                previewPointer = p;
            }
        }
    }
    
    var _processChoice = function(u,p,c){
        Do.Ajax("/processor",{ p: p, c: c, u: u });
    }

    return {
        init:function(){
            _init();
            Debug.log('Assessment initialised');
        },
        progressLoader:function(){
            _progressLoader();
        },
        showTab:function(p,b){
            _showTab(p,b);
        },
        processChoice:function(u,p,c){
            _processChoice(u,p,c);
        },
    }

}();
